export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/sharediscount.png?6a49d226300f054fe7a7bb4cae8e9e64";